import { useMemo } from 'react';
import { CaretDown } from '@phosphor-icons/react';
import { Avatar, Button, Dropdown, Spin } from 'antd';
import type { MenuProps } from 'antd';
import { useGlobalContext } from '../contexts';
import { COLOR } from '../styles/theme';

export function WarehouseDropdown() {
  const {
    warehouseId,
    warehouseLoading,
    warehouseOptions,
    changeWarehouse,
    currentWarehouse,
  } = useGlobalContext();

  const menuItems: MenuProps['items'] = useMemo(
    () =>
      warehouseOptions.map(opt => ({
        key: opt.key,
        label: opt.text,
        onClick: () => changeWarehouse(opt.value),
      })),
    [warehouseOptions, changeWarehouse],
  );

  const warehouseName = currentWarehouse?.name ?? 'Warehouse';
  const warehouseInitial = warehouseName.charAt(0).toUpperCase();

  if (warehouseLoading) {
    return <Spin size="small" />;
  }

  return (
    <Dropdown
      menu={{
        items: menuItems,
        selectable: true,
        selectedKeys: warehouseId ? [warehouseId] : [],
      }}
      trigger={['click']}
    >
      <Button
        variant="outlined"
        color="default"
        style={{ display: 'flex', alignItems: 'center', gap: 6, maxWidth: 220 }}
      >
        <Avatar size="small" style={{ backgroundColor: COLOR.accent, fontSize: 11 }}>
          {warehouseInitial}
        </Avatar>
        <span
          style={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          {warehouseName}
        </span>
        <CaretDown size={14} />
      </Button>
    </Dropdown>
  );
}
